/* Butter Crayon - shared click-to-play video behaviour.
   Any <video data-bc-play> anywhere on the site gets a play button,
   plays once with sound, then stops and offers a replay.
   Every <video> inside page/blog/product content (.rte) gets it too,
   so it still works after the Shopify admin editor strips data-bc-play.
   Before playing, the video shows its bright first frame with a yellow play button:
   no dark tint and no player bar until someone clicks.
   Swap the <source src> for a new video and the styling carries over. */
(function () {
  var CSS = ''
    + '.bc-video-wrap{position:relative;display:inline-block;width:100%;overflow:hidden;line-height:0;border-radius:12px;}'
    + '.bc-video-wrap video{display:block;width:100%;height:auto;border-radius:0;}'
    + '.bc-video-cta{position:absolute;top:0;left:0;width:100%;height:100%;border:0;margin:0;padding:0;'
    + 'cursor:pointer;background:transparent;display:flex;flex-direction:column;align-items:center;'
    + 'justify-content:center;gap:10px;line-height:normal;z-index:2;}'
    + '.bc-video-circle{display:flex;align-items:center;justify-content:center;width:74px;height:74px;'
    + 'border-radius:50%;background:#ffd700;box-shadow:0 4px 14px rgba(0,0,0,.35);}'
    + '.bc-video-label{background:#ffffff;color:#121212;font-weight:700;font-size:.95em;'
    + 'padding:7px 16px;border-radius:99px;box-shadow:0 2px 8px rgba(0,0,0,.25);}'
    + '@media (max-width:480px){.bc-video-circle{width:58px;height:58px;}.bc-video-label{font-size:.85em;}}';

  var PLAY_SVG = '<svg viewBox="0 0 24 24" width="30" height="30" fill="#121212" aria-hidden="true">'
    + '<path d="M8 5v14l11-7z"/></svg>';

  function injectCSS() {
    if (document.getElementById('bc-video-css')) { return; }
    var s = document.createElement('style');
    s.id = 'bc-video-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function upgrade(v) {
    if (v.getAttribute('data-bc-ready')) { return; }
    v.setAttribute('data-bc-ready', '1');

    // never autoplay, never loop
    v.removeAttribute('autoplay');
    v.removeAttribute('loop');
    v.autoplay = false;
    v.loop = false;
    if (!v.paused) { v.pause(); v.currentTime = 0; }
    v.controls = false;
    v.removeAttribute('controls');
    v.setAttribute('playsinline', '');
    if (!v.getAttribute('preload')) { v.setAttribute('preload', 'metadata'); }
    if (!v.getAttribute('poster') && !v.hasAttribute('data-bc-image-poster')) {
      var srcs = v.querySelectorAll('source');
      for (var k = 0; k < srcs.length; k++) {
        var u = srcs[k].getAttribute('src') || '';
        if (u && u.indexOf('#') === -1) { srcs[k].setAttribute('src', u + '#t=0.1'); }
      }
      v.load();
    }

    var poster = v.hasAttribute('data-bc-image-poster') ? v.parentElement.querySelector('.bc-video-poster') : null;
    var wrap = document.createElement('div');
    wrap.className = 'bc-video-wrap';
    if (v.style.maxWidth) { wrap.style.maxWidth = v.style.maxWidth; v.style.maxWidth = '100%'; }
    if (v.style.borderRadius) { wrap.style.borderRadius = v.style.borderRadius; }
    v.parentNode.insertBefore(wrap, v);
    wrap.appendChild(v);
    if (poster) {
      wrap.appendChild(poster);
      v.addEventListener('playing', function () { poster.hidden = true; });
      v.addEventListener('ended', function () { poster.hidden = false; });
      v.addEventListener('error', function () { poster.hidden = false; });
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bc-video-cta';
    btn.setAttribute('aria-label', v.getAttribute('aria-label') || 'Click to play video');
    btn.innerHTML = '<span class="bc-video-circle">' + PLAY_SVG + '</span>'
      + '<span class="bc-video-label">Click to play</span>';
    wrap.appendChild(btn);

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      btn.style.display = 'none';
      v.controls = true;
      v.muted = false;
      v.volume = 1;
      var p = v.play();
      if (p && p.catch) {
        p.catch(function () { v.muted = true; v.play().catch(function () {}); });
      }
    });

    v.addEventListener('ended', function () {
      v.currentTime = 0;
      v.controls = false;
      btn.style.display = 'flex';
    });
  }

  function scan() {
    injectCSS();
    var list = document.querySelectorAll('video[data-bc-play], .rte video');
    for (var i = 0; i < list.length; i++) { upgrade(list[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();
